import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    errorText: {
      color: theme.colors.redOrange,
      margin: '4px 0 0 0',
    },
    summaryTable: {
      borderSpacing: '0 24px',
      // borderCollapse: 'collapse',
      verticalAlign: 'text-top',
      '& td': {
        // height: '64px', // works like minHeight
        verticalAlign: 'text-top',
      },
    },
  }),
  { name: 'Review' },
);

export default useStyles;
